export const BANK_ACCOUNTS_GET = 'bankAccountsGet'
export const BANK_ACCOUNT_CREATE = 'bankAccountCreate'
export const BANK_ACCOUNT_DEFAULT = 'bankAccountDefault'
export const BANK_ACCOUNT_DELETE = 'bankAccountDelete'
export const FINANCE_GET = 'financeGet'
export const FINANCE_GET_ID = 'financeGetID'
export const FINANCE_CREATE = 'financeCreate'
export const FINANCE_SEARCH = 'financeSearch'
export const PAYMENT_SEARCH = 'paymentSearch'
export const MOVEMENT_ACCOUNT_CREATE = 'movementAccountCreate'
export const MOVEMENT_ACCOUNT_DELETE = 'movementAccountDelete'
export const RECEIPT_ACCOUNT_CREATE = 'receiptAccountCreate'
export const RECEIPT_ACCOUNT_DELETE = 'receiptAccountDelete'
export const MOVEMENT_ACCOUNTS_GET = 'movementAccountsGet'
export const MOVEMENT_ACCOUNTS_BANKS_GET = 'movementAccountsBanksGet'
export const RECEIPT_ACCOUNTS_GET = 'receiptAccountsGet'
export const ACCOUNTS_LIST_GET = 'accountsListGet'